module.exports = __webpack_public_path__ + "static/media/Bluelab pH Probe KCl Storage Solution_250 ml.34c4dc6a.webp";